import { TooltipProps } from '@mui/material';
import { ResponsiveStyleValue } from '@mui/system';

export const PAGE_PADDING: ResponsiveStyleValue<number> = {
  xs: 2,
  md: 4,
};

export const DEFAULT_TOOLTIP_PROPS: Partial<TooltipProps> = {
  placement: 'top',
  arrow: true,
  slotProps: {
    popper: {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, -5],
          },
        },
      ],
    },
  },
};
